export default __webpack_public_path__ + "static/media/bg-LOA.d3f5dc19.jpg";